import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const PME = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Introduction to Managers and Management: Management an Overview, Definition of Management, Role of Management, Functions of Managers, Levels of Management, Management Skills and Organizational Hierarchy, Social and Ethical Responsibilities of Management: Arguments for and against Social Responsibilities of Business, Social Stakeholders, Measuring Social Responsiveness and Managerial Ethics, Omnipotent and Symbolic View, Characteristics and importance of organizational culture, Relevance of political, legal, economic and Cultural environments to global business, Structures and techniques organizations use as they go international.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Planning: Nature & Purpose, Steps involved in Planning, Objectives, Setting Objectives, Process of Managing by Objectives, Strategies, Policies & Planning Premises, Competitor Intelligence, Benchmarking, Forecasting, Decision-Making, Directing: Scope, Human Factors, Creativity and Innovation, Harmonizing Objectives, Leadership, Types of Leadership, Directing, Managers as leaders, Early Leadership Theories…Trait Theories, Behavioral Theories, Managerial Grid, Contingency Theories of Leadership, Directing ...PathGoal Theory, contemporary views of Leadership, CrossCultural Leadership, Leadership Training, Substitutes of Leadership.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Organizing: Organizing, Benefits and Limitations-De-Centralization and Delegation of Authority, Authority versus Power, Mechanistic Versus Organic Organization, Common Organizational Designs, Contemporary Organizational Designs and Contingency Factors, The Learning Organization Nature and Purpose, Formal and Informal Organization, Organization Chart, Structure and Process, Departmentalization by difference strategies, Line and Staff authority- Benefits and Limitations-De-Centralization and Delegation of Authority Versus, Staffing, Human Resource Inventory, Job Analysis, Job Description, Recruitment and.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Controlling: Controlling, Introduction to Controlling System and process of Controlling, Requirements for effective control, The planning Control link, The process of control, types of control The Budget as Control Technique, Information Technology in Controlling, Productivity, Problems and Management, Control of Overall Performance, Direct and Preventive Control, Financial Controls, Tools for measuring organizational Performance, Contemporary issues in control Workplace concerns, employee theft, employee violence.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'books',
      label: 'Books',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null, // Will be replaced in SubjectPage
    },
    {
      id: 'youtube_playlist',
      label: 'Video Lectures',
      content: null, // Will be replaced in SubjectPage
    },
  ];

  return (
    <SubjectPage
      subjectName="Principles of Management for Engineers"
      subjectKey="PME"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'PMENotes',
        videos: 'PMEVideos'
      }}
    />
  );
};

export default PME;